






























































































import axios from "axios";
import Popper from "popper.js";
import { namespace } from "vuex-class";
import { Component, Emit, Prop, Vue, Watch } from "vue-property-decorator";

import { Code } from "@/types";
import { excludes } from "@/codes";
import { Settings } from "@/store/settings";
import CodeList from "@/components/CodeList.vue";
import Tooltip from "@/components/Tooltip.vue";

interface RawEvidence {
  conceptid: string;
  syn: string;
  billable?: boolean;
}

const SettingsStore = namespace("settings");

@Component({
  components: { Tooltip, CodeList }
})
export default class CodeSearch extends Vue {
  private popper: Popper | null = null;

  private data: RawEvidence[] = [];

  private navigated: RawEvidence | null = null;

  private timeout?: number;

  @Prop()
  private term!: string;

  @Prop()
  private existing!: string[];

  @Prop()
  private range!: [number, number];

  @SettingsStore.State("current")
  private settings!: Settings;

  @Watch("term")
  async update() {
    this.data = [];

    const response = await axios.post(
      this.settings.endpoints.search,
      this.term
    );

    if (response.status === 200) {
      this.data = response.data.content;
    }
  }

  @Emit()
  select(code: RawEvidence) {
    this.hide(0);

    return {
      id: code.conceptid,
      desc: code.syn,
      spans: this.range ? [this.range] : [],
      billable: code.billable
    };
  }

  @Emit("select")
  selectFromNavigation(code: Code) {
    const evidence = {
      code: code.id,
      name: code.desc,
      spans: this.range ? [this.range] : [],
      billable: code.billable
    };

    this.hide(0);

    return evidence;
  }

  navigate(event: Event, evidence: RawEvidence) {
    this.cancelHide();
    this.navigated = evidence;

    if (event.target instanceof Element && this.$refs.popover instanceof Vue) {
      if (this.popper) {
        this.popper.reference = event.target;
      } else {
        this.popper = new Popper(
          event.target,
          (this.$refs.popover as Vue).$el,
          {
            placement: "left",
            modifiers: {
              preventOverflow: {
                boundariesElement: "viewport"
              },
              computeStyle: {
                gpuAcceleration: false
              }
            }
          }
        );
      }

      this.updatePopper();
    }
  }

  hide(timeout: number = 500) {
    this.timeout = window.setTimeout(() => {
      if (this.popper) {
        this.popper.destroy();
        this.popper = null;
      }
    }, timeout);
  }

  cancelHide() {
    if (this.timeout) window.clearTimeout(this.timeout);
  }

  updatePopper() {
    this.$nextTick(() => {
      if (this.popper) this.popper.update();
    });
  }

  isExcluded(code: RawEvidence) {
    return (excludes[code.conceptid] || []).filter(value =>
      this.existing.includes(value)
    );
  }
}
